import React from 'react';
import {Callout, Intent} from '@blueprintjs/core';
import {IconNames} from '@blueprintjs/icons';

import './Result.scss';

interface ResultSuccessProps {
  title: string;
  description?: string;
}

export const ResultSuccess = ({
  title,
  description,
}: ResultSuccessProps) => {
  /*
   * Default `ResultSuccess`
   */
  if (!description) {
    return null;
  }

  return (
    <Callout
      title={title}
      icon={IconNames.TICK}
      intent={Intent.SUCCESS}
    >
      <div dangerouslySetInnerHTML={{__html: description}}></div>
    </Callout>
  )
};
